import { FC } from 'react';

import * as Styles from './buttons.styles';

type BigButtonOutlined = {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  children: string;
} & React.HTMLAttributes<HTMLButtonElement>;

const BigButtonOutlined: FC<BigButtonOutlined> = (props) => {
  return (
    <Styles.BigButtonOutlined {...props} id={props.id || 'big-button'} />
  );
};

export default BigButtonOutlined;
